module.exports = __webpack_public_path__ + "static/media/38_A.4700fe74.png";